export enum RouteType {
  Ride = 1,
  Run = 2,
}
